
import state from './moduleActionTypeManagementState'
import mutations from './moduleActionTypeManagementMutations'
import actions from './moduleActionTypeManagementActions'
import getters from './moduleActionTypeManagementGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

